// extracted by mini-css-extract-plugin
export default {"loadingContainer":"IHvhMP_m82gx5f71sXeq","loading":"VrbpN2b7rnLJBsPQgWR1","placeHolderShimmer":"jP2_B4dsbvicKCMqdKLq"};